import React from "react";
import { Link } from "react-router-dom";

const TaxiRates = () => {
  const handleBooking = () => {
    // window.location.replace("https://eb3.autocab.net/#/33710");
    window.open("https://eb3.autocab.net/#/33710", "_blank");
  };
  return (
    <div className="pb-5">
      <div className="container ">
        <div className="row">
          <div className="col-lg-12 text-center mb-4">
            <p className="red-clr f-16 lh-1 mt-5 f-pop-med">Taxi Rates</p>
            <p className="clr-ob f-47 lh-1 mb-2 f-pop-med">
              Book London Stansted airport Taxi transfers
            </p>
          </div>
          <div className="col-lg-12 mt-4">
            <div className="row">
              <div className="col-lg-4">
                <div className="card blu_card_taxi pos-rel mb-5">
                  <div className="card-body pb-2rem">
                    <div className="white_box_taxi">
                      <p className="f-25 f-pop-semibold">Luton Airport </p>
                    </div>
                    <p className="f-16 text-white mt-3 ml-1 f-pop-med">
                      Stansted Airport to Luton Airport is a 42 mile connecting
                      journey{" "}
                    </p>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <ul className="ul_pad_zero">
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Saloon</span>
                          <span className="f-15 f-pop-med">£90</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Estate</span>
                          <span className="f-15 f-pop-med">£95</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">MPV</span>
                          <span className="f-15 f-pop-med">£135</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Mini Bus</span>
                          <span className="f-15 f-pop-med">£170</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Executive</span>
                          <span className="f-15 f-pop-med">£110</span>
                        </div>
                      </li>
                      {/* <li className="ul_tick_round_white text-white">
                                                <div className='d-flex justify-spacebt'>
                                                    <span className='f-14 f-pop-med'>Extra Passangers</span>
                                                    <span className='f-15 f-pop-med'>$2.40/km</span>
                                                </div>
                                            </li> */}
                    </ul>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <div className="d-flex justify-spacebt">
                      <span className="clr-crd-red-blaa f-14 text-white f-pop-med">
                        Want to discuss contact us
                      </span>
                      <span className="clr-crd-red-blaa-brabr f-15 text-white f-pop-med">
                        +441279 247 247
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="red_brdr_blue_card"></div>
                      </div>
                    </div>
                    <div className="d-flex justify-center">
                      {/* <Link style={{ textDecoration: "none", color: "white" }} to="/booking">
                                                <button className='btn btn-light p-bt-cus-blu-crd f-16 text-dark f-pop-semibold'>
                                                    Book Now
                                                </button>
                                            </Link> */}
                      <a style={{ textDecoration: "none", color: "white" }}>
                        <button
                          className="btn btn-light p-bt-cus-blu-crd f-16 text-dark f-pop-semibold"
                          onClick={handleBooking}
                        >
                          Book Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="card blu_card_taxi pos-rel mb-5">
                  <div className="card-body pb-2rem">
                    <div className="white_box_taxi">
                      <p className="f-25 f-pop-semibold">Gatwick Airport</p>
                    </div>
                    <p className="f-16 text-white mt-3 ml-1 f-pop-med">
                      Stansted Airport to Gatwick Airport is a 73 mile
                      connecting journey
                    </p>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <ul className="ul_pad_zero">
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Saloon</span>
                          <span className="f-15 f-pop-med">£120</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Estate</span>
                          <span className="f-15 f-pop-med">£125</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">MPV</span>
                          <span className="f-15 f-pop-med">£170</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Mini Bus</span>
                          <span className="f-15 f-pop-med">£230</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Executive</span>
                          <span className="f-15 f-pop-med">£140</span>
                        </div>
                      </li>
                      {/* <li className="ul_tick_round_white text-white">
                                                <div className='d-flex justify-spacebt'>
                                                    <span className='f-14 f-pop-med'>Extra Passangers</span>
                                                    <span className='f-15 f-pop-med'>$2.40/km</span>
                                                </div>
                                            </li> */}
                    </ul>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <div className="d-flex justify-spacebt">
                      <span className="clr-crd-red-blaa f-14 text-white f-pop-med">
                        Want to discuss contact us
                      </span>
                      <span className="clr-crd-red-blaa-brabr f-15 text-white f-pop-med">
                        +441279 247 247
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="red_brdr_blue_card"></div>
                      </div>
                    </div>
                    <div className="d-flex justify-center">
                      {/* <Link
                        style={{ textDecoration: "none", color: "white" }}
                        to="/booking"
                      >
                        <button className="btn btn-light p-bt-cus-blu-crd f-16 text-dark f-pop-semibold">
                          Book Now
                        </button>
                      </Link> */}
                      <a style={{ textDecoration: "none", color: "white" }}>
                        <button
                          className="btn btn-light p-bt-cus-blu-crd f-16 text-dark f-pop-semibold"
                          onClick={handleBooking}
                        >
                          Book Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="card blu_card_taxi pos-rel mb-5">
                  <div className="card-body pb-2rem">
                    <div className="white_box_taxi">
                      <p className="f-25 f-pop-semibold">Heathrow Airport</p>
                    </div>
                    <p className="f-16 text-white mt-3 ml-1 f-pop-med">
                      Stansted Airport to Heathrow Airport is a 65 mile
                      connecting mile journey
                    </p>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <ul className="ul_pad_zero">
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Saloon</span>
                          <span className="f-15 f-pop-med">£120</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Estate</span>
                          <span className="f-15 f-pop-med">£125</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">MPV</span>
                          <span className="f-15 f-pop-med">£170</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Mini Bus</span>
                          <span className="f-15 f-pop-med">£230</span>
                        </div>
                      </li>
                      <li className="ul_tick_round_white text-white">
                        <div className="d-flex justify-spacebt">
                          <span className="f-14 f-pop-med">Executive</span>
                          <span className="f-15 f-pop-med">£140</span>
                        </div>
                      </li>
                      {/* <li className="ul_tick_round_white text-white">
                                                <div className='d-flex justify-spacebt'>
                                                    <span className='f-14 f-pop-med'>Extra Passangers</span>
                                                    <span className='f-15 f-pop-med'>$2.40/km</span>
                                                </div>
                                            </li> */}
                    </ul>
                    <div className="brdr-btn_taxi_card mx-3 my-4"></div>
                    <div className="d-flex justify-spacebt">
                      <span className="clr-crd-red-blaa f-14 text-white f-pop-med">
                        Want to discuss contact us
                      </span>
                      <span className="clr-crd-red-blaa-brabr f-15 text-white f-pop-med">
                        +441279 247 247
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="red_brdr_blue_card"></div>
                      </div>
                    </div>
                    <div className="d-flex justify-center">
                      <Link
                        style={{ textDecoration: "none", color: "white" }}
                        to="/booking"
                      >
                        <button className="btn btn-light p-bt-cus-blu-crd f-16 text-dark f-pop-semibold">
                          Booking now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxiRates;
